module.exports = "/_next/static/media/88ec167aaaf0842da922c07ab208e740.svg";